import React, { Component, ErrorInfo, ReactNode } from 'react';
import styled from 'styled-components';

import { AppWrapper } from './components/AppWrapper';
import { Header } from './components/Header';
import { Error } from './components/ProductBuilder/Error';

type Props = {
  children: ReactNode | ReactNode[];
};

type State = {
  hasError: boolean;
};

const ErrorHeading = styled.h2`
  margin-top: 0;
`;

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <AppWrapper>
          <Header />
          <Error>
            <ErrorHeading>Oh no! Sorry, something went wrong.</ErrorHeading>
            <p>
              Our team has been notified of the problem, and we'll try to fix it
              as soon as possible.
            </p>
          </Error>
        </AppWrapper>
      );
    }

    return this.props.children;
  }
}
